import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import NavMenu from "../NavMenu/NavMenu";

import { scrollToSection } from "../../helpers/utilities";

import './header.css'

export default function Header() {
    const location = useLocation();
    const [isScrolling, setIsScrolling ] = useState(false);

    useEffect(() => {
      document.addEventListener("scroll", function (e) {
        var scrollTop = document.body.getBoundingClientRect().top;

        if (scrollTop <= -725) {
          setIsScrolling(true);
        } else {
          setIsScrolling(false);
        }
      });
    }, [setIsScrolling]);

    useEffect(() => {
      if (location.hash) {
        var tElement = document.querySelector(location.hash) as HTMLElement;
        if (tElement) {
          scrollToSection(tElement);
        }
      }
    }, [location]);

    return (
        <header className={isScrolling === true ? "scrolling" : ""}>
            <div className="inner">
                <a href="/" className="logo"><img src="/logo.jpeg" alt="Logo" /></a>
                <NavMenu />
            </div>
        </header>
    )
}